module.exports = __webpack_public_path__ + "img/Bitecla-logo1.ed533ebd.svg";